import { useState, useEffect } from "react";

// Tracks a CSS media query and re-renders when it starts/stops matching.
// e.g. const isMobile = useMediaQuery("(max-width: 768px)");
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const fn = () => setMatches(mq.matches);
    fn();
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, [query]);

  return matches;
};
